import * as numeral from 'numeral';

export function initialize(locale: string) {
    // if (locale !== "sk") {
    //     throw new Error("Expecting sk locale"); //see check* methods, they use , as separator (+ allows space in text), from Karma
    // }
    numeral.locale(locale);
}

export function create(value: number) {
    return {
        format: (format: string) => numeral(value).format(format)
    };
}

export function checkUserFloatValue(value: string) {
    var pattern = /^(\d+ \d{2})*\d+([,\.]\d*)?$/;
    return pattern.test(value);
};

export function getFloatValueFromUserText(value: string) {
    return parseFloat(value.replace(/ /g, "").replace(/,/g, "."));
};

export function checkUserIntValue(value: string) {
    var pattern = /^(\d+ \d{2})*\d+$/;
    return pattern.test(value);
};

export function getIntValueFromUserText(value: string) {
    return parseInt(value.replace(/ /g, ""), 10);
};
